export default "__VITE_ASSET__DBy3gqyz__"